import { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    object: 'training',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Votre message a été envoyé ! Nous vous répondrons dans les plus brefs délais.');
    // Ici, vous pouvez ajouter une logique d'envoi vers une API
  };

  return (
    <>
      <style>{`
        /* ============================================
           CONTACT – fond bleu solide
           ============================================ */
        .ve-contact-section {
          padding: 100px 0 80px;
          background: #0a1628;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          color: #ffffff;
          position: relative;
          overflow: hidden;
           max-width: 100%;
        }

        .ve-contact-section::before {
          content: '';
          position: absolute;
          top: -20%;
          left: -10%;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(42, 95, 168, 0.08), transparent 70%);
          border-radius: 50%;
          pointer-events: none;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
          position: relative;
          z-index: 2;
        }

        /* En-tête */
        .ve-contact-header {
          text-align: center;
          margin-bottom: 56px;
          animation: fadeUp 0.8s ease forwards;
          opacity: 0;
          transform: translateY(30px);
        }

        .ve-section-tag {
          display: inline-block;
          background: rgba(74, 144, 226, 0.15);
          color: #4a90e2;
          font-size: 0.85rem;
          font-weight: 600;
          letter-spacing: 0.5px;
          padding: 6px 20px;
          border-radius: 50px;
          text-transform: uppercase;
          margin-bottom: 16px;
        }

        .ve-contact-header h2 {
          font-size: clamp(2rem, 4.5vw, 3.2rem);
          font-weight: 800;
          color: #ffffff;
          margin: 0 0 12px;
          letter-spacing: -0.5px;
        }

        .ve-contact-header h2 span {
          background: linear-gradient(135deg, #4a90e2, #6bb3e8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .ve-contact-header p {
          font-size: 1.1rem;
          color: rgba(255,255,255,0.75);
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.7;
        }

        /* Contenu principal */
        .ve-contact-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
          align-items: start;
        }

        /* Formulaire */
        .ve-contact-form-wrapper {
          background: rgba(255,255,255,0.04);
          backdrop-filter: blur(6px);
          border: 1px solid rgba(255,255,255,0.06);
          border-radius: 24px;
          padding: 36px 32px 32px;
          animation: cardFadeUp 0.8s ease 0.05s forwards;
          opacity: 0;
          transform: translateY(30px);
        }

        @keyframes cardFadeUp {
          to { opacity: 1; transform: translateY(0); }
        }

        .ve-contact-form-wrapper h3 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 6px;
        }

        .ve-contact-form-wrapper > p {
          font-size: 0.95rem;
          color: rgba(255,255,255,0.7);
          margin: 0 0 24px;
        }

        .ve-form-group {
          margin-bottom: 18px;
        }

        .ve-form-group label {
          display: block;
          font-size: 0.9rem;
          font-weight: 500;
          color: rgba(255,255,255,0.8);
          margin-bottom: 6px;
        }

        .ve-form-group input,
        .ve-form-group select,
        .ve-form-group textarea {
          width: 100%;
          padding: 12px 16px;
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(255,255,255,0.10);
          border-radius: 12px;
          font-size: 1rem;
          font-family: inherit;
          color: #ffffff;
          transition: border-color 0.3s, box-shadow 0.3s, background 0.3s;
          outline: none;
        }

        .ve-form-group input:focus,
        .ve-form-group select:focus,
        .ve-form-group textarea:focus {
          border-color: #4a90e2;
          background: rgba(255,255,255,0.08);
          box-shadow: 0 0 0 4px rgba(74, 144, 226, 0.15);
        }

        .ve-form-group input::placeholder,
        .ve-form-group textarea::placeholder {
          color: rgba(255,255,255,0.4);
        }

        .ve-form-group select option {
          background: #0a1628;
          color: #ffffff;
        }

        .ve-form-group textarea {
          resize: vertical;
          min-height: 120px;
        }

        .ve-submit-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 14px 40px;
          background: linear-gradient(135deg, #2b7fd4, #4a90e2);
          color: #ffffff;
          font-weight: 600;
          font-size: 1rem;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          box-shadow: 0 0 28px rgba(42, 95, 168, 0.35);
          transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
          position: relative;
          overflow: hidden;
        }

        .ve-submit-btn::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, #4a90e2, #2b7fd4);
          opacity: 0;
          transition: opacity 0.4s ease;
          border-radius: 50px;
        }

        .ve-submit-btn:hover {
          transform: translateY(-3px) scale(1.02);
          box-shadow: 0 0 48px rgba(42, 95, 168, 0.55);
        }

        .ve-submit-btn:hover::before {
          opacity: 1;
        }

        .ve-submit-btn span {
          position: relative;
          z-index: 1;
        }

        /* Informations de contact */
        .ve-contact-info-wrapper {
          display: flex;
          flex-direction: column;
          gap: 30px;
          animation: cardFadeUp 0.8s ease 0.10s forwards;
          opacity: 0;
          transform: translateY(30px);
        }

        .ve-contact-card {
          background: rgba(255,255,255,0.04);
          backdrop-filter: blur(6px);
          border: 1px solid rgba(255,255,255,0.06);
          border-radius: 24px;
          padding: 28px 24px;
          transition: transform 0.3s, background 0.3s, border-color 0.3s;
        }

        .ve-contact-card:hover {
          transform: translateY(-4px);
          background: rgba(255,255,255,0.07);
          border-color: rgba(74, 144, 226, 0.2);
        }

        .ve-contact-card h4 {
          font-size: 1.1rem;
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 12px;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .ve-contact-card h4 i {
          color: #4a90e2;
          font-size: 1.3rem;
          width: 28px;
          text-align: center;
        }

        .ve-contact-card p,
        .ve-contact-card a {
          font-size: 0.95rem;
          line-height: 1.6;
          color: rgba(255,255,255,0.8);
          margin: 0;
          text-decoration: none;
        }

        .ve-contact-card a:hover {
          color: #4a90e2;
        }

        .ve-contact-card .ve-address {
          font-style: normal;
          line-height: 1.7;
        }

        /* Carte Google Maps */
        .ve-map-wrapper {
          border-radius: 24px;
          overflow: hidden;
          border: 1px solid rgba(255,255,255,0.06);
          box-shadow: 0 8px 30px rgba(0,0,0,0.3);
          transition: transform 0.3s ease;
        }

        .ve-map-wrapper:hover {
          transform: scale(1.01);
        }

        .ve-map-wrapper iframe {
          width: 100%;
          height: 280px;
          border: 0;
          display: block;
        }

        /* Animations */
        @keyframes fadeUp {
          to { opacity: 1; transform: translateY(0); }
        }

        /* Responsive */
        @media (max-width: 992px) {
          .ve-contact-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }
          .ve-contact-form-wrapper {
            order: 2;
          }
          .ve-contact-info-wrapper {
            order: 1;
          }
        }

        @media (max-width: 768px) {
          .ve-contact-section {
            padding: 70px 0 50px;
          }
          .ve-contact-form-wrapper {
            padding: 24px 18px;
          }
          .ve-contact-card {
            padding: 20px 16px;
          }
          .ve-map-wrapper iframe {
            height: 220px;
          }
        }

        @media (max-width: 480px) {
          .ve-contact-form-wrapper h3 {
            font-size: 1.3rem;
          }
          .ve-submit-btn {
            width: 100%;
            justify-content: center;
          }
          .ve-map-wrapper iframe {
            height: 180px;
          }
        }

        /* Fallback FontAwesome */
        .fa, .fas, .far, .fal, .fab {
          font-family: 'Font Awesome 6 Free' !important;
          font-weight: 900;
        }
        .fa-map-marker::before { content: "📍"; font-style: normal; }
        .fa-phone::before { content: "📞"; font-style: normal; }
        .fa-envelope::before { content: "✉️"; font-style: normal; }
        .fa-globe::before { content: "🌐"; font-style: normal; }
      `}</style>

      <section className="ve-contact-section">
        <div className="container">
          <div className="ve-contact-header">
            <span className="ve-section-tag">Contact</span>
            <h2>Parlons de votre <span>projet</span></h2>
            <p>
              Vous avez une question, un besoin de formation ou un projet RH ?
              Remplissez le formulaire ou contactez-nous directement.
            </p>
          </div>

          <div className="ve-contact-grid">
            {/* Formulaire */}
            <div className="ve-contact-form-wrapper">
              <h3>Écrivez-nous</h3>
              <p>Nous vous répondrons sous 24h ouvrées.</p>
              <form onSubmit={handleSubmit}>
                <div className="ve-form-group">
                  <label htmlFor="name">Nom complet *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Votre nom"
                    required
                  />
                </div>
                <div className="ve-form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="votre@email.com"
                    required
                  />
                </div>
                <div className="ve-form-group">
                  <label htmlFor="phone">Téléphone</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+243 85106166"
                  />
                </div>
                <div className="ve-form-group">
                  <label htmlFor="object">Objet *</label>
                  <select
                    id="object"
                    name="object"
                    value={formData.object}
                    onChange={handleChange}
                    required
                  >
                    <option value="training">Formation</option>
                    <option value="recruitment">Recrutement</option>
                    <option value="hr-consulting">Conseil RH</option>
                    <option value="other">Autre</option>
                  </select>
                </div>
                <div className="ve-form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Décrivez votre demande..."
                    required
                  />
                </div>
                <button type="submit" className="ve-submit-btn">
                  <span>Envoyer le message</span>
                </button>
              </form>
            </div>

            {/* Informations de contact + Carte */}
            <div className="ve-contact-info-wrapper">
              <div className="ve-contact-card">
                <h4><i className="fa fa-map-marker"></i> Adresse</h4>
                <p className="ve-address">
                  Nouvelle galerie présémiante Rcm 7-8 ex bureau agrad<br />
                  Rez de chaussée, Maasdam 7-8<br />
                  Republic of Congo / DRC
                </p>
              </div>

              <div className="ve-contact-card">
                <h4><i className="fa fa-phone"></i> Téléphone</h4>
                <p><a href="tel:+24385106166">+243 85106166</a></p>
              </div>

              <div className="ve-contact-card">
                <h4><i className="fa fa-envelope"></i> Email</h4>
                <p><a href="mailto:contact@bisenter.com">contact@bisenter.com</a></p>
              </div>

              <div className="ve-contact-card">
                <h4><i className="fa fa-globe"></i> Site web</h4>
                <p><a href="https://www.bisenter.com" target="_blank" rel="noopener noreferrer">www.bisenter.com</a></p>
              </div>

              {/* Carte Google Maps */}
              <div className="ve-map-wrapper">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d255743.68951876374!2d15.2339347!3d-4.334556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1a6a5fe4dce0f4d3%3A0x9a9a5b0e7e6d4e9!2sKinshasa%2C%20Democratic%20Republic%20of%20the%20Congo!5e0!3m2!1sen!2s!4v1700000000000"
                  allowFullScreen=""
                  loading="lazy"
                  title="Localisation 3iSENTER"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;